module.exports = __webpack_public_path__ + "static/img/3.f503f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/3.jpg
// module id = gS1b
// module chunks = 1